export default [
  {
    name: 'Entry',
    path: '/bmwgroup-initiativbewerbung',
    component: () => import('@user/views_legacy/Custom/BmwInitiativ/Entry'),
    redirect: '/bmwgroup-initiativbewerbung/landing',
    children: [
      { path: 'login/landing', redirect: 'landing' },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/Login'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'landing',
        name: 'Landing',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/Landing'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'registration',
        name: 'Registration',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/Registration'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/ForgotPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'reset-password/:userHash/:language',
        name: 'ResetPassword',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/ResetPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'account-activation',
        name: 'AccountActivation',
        component: () =>
          import('@user/views_legacy/Custom/BmwInitiativ/Routes/AccountActivation'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'activation/:userHash/:language',
        name: 'ActivationLogin',
        component: () =>
          import('@user/views_legacy/Custom/BmwInitiativ/Routes/ActivationLogin'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'profileChooser',
        name: 'ProfileChooser',
        component: () => import('@user/views_legacy/Default/Routes/ProfileChooser'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Home',
            icon: 'IconHome',
            to: { name: 'ProfileChooser' },
            rank: 5,
          },
        },
      },
      {
        path: 'home',
        name: 'Home',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/Home'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Dashboard',
            icon: 'IconHome',
            to: { name: 'Home' },
            rank: 10,
          },
        },
      },
      {
        path: 'FAQ',
        name: 'FAQ',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/FAQ'),
        meta: {
          layout: 'Dashboard',
          link: { name: 'FAQ', icon: 'IconFAQ', to: { name: 'FAQ' }, rank: 40 },
        },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/Profile'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Profile',
            icon: 'IconProfile',
            to: { name: 'Profile' },
            rank: 20,
          },
        },
      },
      {
        path: 'assessment',
        name: 'ModuleArea',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/ModuleArea'),
        meta: { layout: 'Dashboard' },
      },
      {
        path: 'page-not-found',
        name: 'Custom_PageNotFound',
        component: () => import('@user/views_legacy/Custom/BmwInitiativ/Routes/PageNotFound'),
        meta: { layout: 'Error' },
      },
      { path: '*', redirect: '/page-not-found' },
    ],
  },
  {
    name: 'Entry',
    path: '/eligo',
    component: () => import('@user/views_legacy/Default/Entry'),
    redirect: '/eligo/landing',
    children: [
      {
        path: 'home',
        name: 'Home',
        components: {
          default: () => import('@user/views_legacy/Default/Routes/Home'),
          side: () => import('@user/views_legacy/Default/Routes/Progress'),
        },
        meta: { layout: 'Dashboard' },
      },
      { path: 'login/landing', redirect: 'login' },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@user/views_legacy/Default/Routes/Login'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'landing',
        name: 'Landing',
        component: () => import('@user/views_legacy/Default/Routes/Landing'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'registration',
        name: 'Registration',
        component: () => import('@user/views_legacy/Default/Routes/Registration'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@user/views_legacy/Default/Routes/ForgotPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'reset-password/:userHash/:language',
        name: 'ResetPassword',
        component: () => import('@user/views/Default/Routes/ResetPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'account-activation',
        name: 'AccountActivation',
        component: () => import('@user/views_legacy/Default/Routes/AccountActivation'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'activation/:userHash/:language',
        name: 'ActivationLogin',
        component: () => import('@user/views_legacy/Default/Routes/ActivationLogin'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'profileChooser',
        name: 'ProfileChooser',
        component: () => import('@user/views_legacy/Default/Routes/ProfileChooser'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Home',
            icon: 'IconHome',
            to: { name: 'ProfileChooser' },
            rank: 5,
          },
        },
      },
      {
        path: 'FAQ',
        name: 'FAQ',
        component: () => import('@user/views_legacy/Default/Routes/FAQ'),
        meta: {
          layout: 'Dashboard',
          link: { name: 'FAQ', icon: 'IconFAQ', to: { name: 'FAQ' }, rank: 40 },
        },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@user/views_legacy/Default/Routes/Profile'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Profile',
            icon: 'IconProfile',
            to: { name: 'Profile' },
            rank: 20,
          },
        },
      },
      {
        path: 'assessment',
        name: 'ModuleArea',
        component: () => import('@user/views_legacy/Default/Routes/ModuleArea'),
        meta: { layout: 'Dashboard' },
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@user/views_legacy/Default/Routes/Report'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Ergebnisbericht',
            icon: 'IconErgebnisbericht',
            to: { name: 'Report' },
            rank: 60,
          },
        },
      },
      {
        path: 'support',
        name: 'Support',
        component: () => import('@user/views_legacy/Default/Routes/Support'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Support',
            icon: 'IconSupport',
            to: { name: 'Support' },
            rank: 70,
          },
        },
      },
      {
        path: 'page-not-found',
        name: 'Custom_PageNotFound',
        component: () => import('@user/views_legacy/Default/Routes/PageNotFound'),
        meta: { layout: 'Error' },
      },
      { path: '*', redirect: '/page-not-found' },
    ],
  },
  {
    name: 'Entry',
    path: '/bmwazubi-dualstudierende',
    component: () =>
      import('@user/views_legacy/Custom/BmwAzubiDuali/Entry'),
    redirect: '/bmwazubi-dualstudierende/landing',
    children: [
      { path: '/', redirect: 'login' },
      {
        path: 'home',
        name: 'Home',
        components: {
          default: () =>
            import('@user/views_legacy/Custom/BmwAzubiDuali/Routes/Home'),
          side: () =>
            import(
              '@user/views_legacy/Custom/BmwAzubiDuali/Routes/Progress'
            ),
        },
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Aufgaben',
            icon: 'IconSupport',
            to: { name: 'Home' },
            rank: 10,
          },
        },
      },
      {
        path: 'home-on-site',
        name: 'HomeOnSite',
        component: () =>
          import(
            '@user/views_legacy/Custom/BmwAzubiDuali/Routes/HomeOnSite'
          ),
        meta: { layout: 'Dashboard' },
      },
      {
        path: 'passwort-aendern',
        name: 'PasswordAendern',
        component: () =>
          import(
            '@user/views_legacy/Custom/BmwAzubiDuali/Routes/PasswordAendern'
          ),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Passwort Ändern',
            icon: 'IconProfile',
            to: { name: 'PasswordAendern' },
            rank: 20,
          },
        },
      },
      { path: 'login/landing', redirect: 'landing' },
      {
        path: 'login',
        name: 'Login',
        component: () =>
          import('@user/views_legacy/Custom/BmwAzubiDuali/Routes/Login'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () =>
          import(
            '@user/views_legacy/Custom/BmwAzubiDuali/Routes/ForgotPassword'
          ),
        meta: { layout: 'Landing' },
      },
      {
        path: 'reset-password/:userHash/:language',
        name: 'ResetPassword',
        component: () => import('@user/views/Default/Routes/ResetPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'profileChooser',
        name: 'ProfileChooser',
        component: () => import('@user/views_legacy/Default/Routes/ProfileChooser'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Home',
            icon: 'IconHome',
            to: { name: 'ProfileChooser' },
            rank: 5,
          },
        },
      },
      {
        path: 'FAQ',
        name: 'FAQ',
        component: () =>
          import('@user/views_legacy/Custom/BmwAzubiDuali/Routes/FAQ'),
        meta: {
          layout: 'Dashboard',
          link: { name: 'FAQ', icon: 'IconFAQ', to: { name: 'FAQ' }, rank: 40 },
        },
      },
      {
        path: 'assessment',
        name: 'ModuleArea',
        component: () =>
          import(
            '@user/views_legacy/Custom/BmwAzubiDuali/Routes/ModuleArea'
          ),
        meta: { layout: 'Dashboard' },
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@user/views/Custom/BmwInitiativ/Routes/Report'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Ergebnisbericht',
            icon: 'IconErgebnisbericht',
            to: { name: 'Report' },
            rank: 60,
          },
        },
      },
      {
        path: 'page-not-found',
        name: 'Custom_PageNotFound',
        component: () => import('@user/views_legacy/Default/Routes/PageNotFound'),
        meta: { layout: 'Error' },
      },
      { path: '*', redirect: '/page-not-found' },
    ],
  },
  {
    name: 'Entry',
    path: '/fbo',
    component: () => import('@user/views_legacy/Default/Entry'),
    redirect: '/fbo/landing',
    children: [
      { path: 'login/landing', redirect: 'landing' },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@user/views_legacy/Default/Routes/Login'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@user/views_legacy/Default/Routes/ForgotPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'reset-password/:userHash/:language',
        name: 'ResetPassword',
        component: () => import('@user/views/Default/Routes/ResetPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'profileChooser',
        name: 'ProfileChooser',
        component: () => import('@user/views_legacy/Default/Routes/ProfileChooser'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Home',
            icon: 'IconHome',
            to: { name: 'ProfileChooser' },
            rank: 5,
          },
        },
      },
      {
        path: 'home',
        name: 'Home',
        component: () => import('@user/views_legacy/Default/Routes/Home'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Dashboard',
            icon: 'IconHome',
            to: { name: 'Home' },
            rank: 10,
          },
        },
      },
      {
        path: 'FAQ',
        name: 'FAQ',
        component: () => import('@user/views_legacy/Default/Routes/FAQ'),
        meta: {
          layout: 'Dashboard',
          link: { name: 'FAQ', icon: 'IconFAQ', to: { name: 'FAQ' }, rank: 40 },
        },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@user/views_legacy/Default/Routes/Profile'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Profile',
            icon: 'IconProfile',
            to: { name: 'Profile' },
            rank: 20,
          },
        },
      },
      {
        path: 'assessment',
        name: 'ModuleArea',
        component: () => import('@user/views_legacy/Default/Routes/ModuleArea'),
        meta: { layout: 'Dashboard' },
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@user/views_legacy/Default/Routes/Report'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Ergebnisbericht',
            icon: 'IconErgebnisbericht',
            to: { name: 'Report' },
            rank: 60,
          },
        },
      },
      {
        path: 'support',
        name: 'Support',
        component: () => import('@user/views_legacy/Default/Routes/Support'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Support',
            icon: 'IconSupport',
            to: { name: 'Support' },
            rank: 70,
          },
        },
      },
      {
        path: 'page-not-found',
        name: 'Custom_PageNotFound',
        component: () => import('@user/views_legacy/Default/Routes/PageNotFound'),
        meta: { layout: 'Error' },
      },
      { path: '*', redirect: '/page-not-found' },
    ],
  },
  {
    name: 'Entry',
    path: '/preview',
    component: () => import('@user/views_legacy/Custom/Preview/Entry'),
    redirect: '/preview/landing',
    children: [
      {
        path: 'newsletter',
        name: 'Newsletter',
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Newsletter',
            icon: 'IconNewsletter',
            to: { name: 'Newsletter' },
            rank: 11,
          },
        },
        component: () => import('@user/views_legacy/Custom/Preview/Routes/Newsletter'),
      },
      { path: 'login/landing', redirect: 'landing' },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@user/views_legacy/Default/Routes/Login'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@user/views_legacy/Default/Routes/ForgotPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'reset-password/:userHash/:language',
        name: 'ResetPassword',
        component: () => import('@user/views/Default/Routes/ResetPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'profileChooser',
        name: 'ProfileChooser',
        component: () => import('@user/views_legacy/Default/Routes/ProfileChooser'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Home',
            icon: 'IconHome',
            to: { name: 'ProfileChooser' },
            rank: 5,
          },
        },
      },
      {
        path: 'home',
        name: 'Home',
        component: () => import('@user/views_legacy/Default/Routes/Home'),
        meta: {
          layout: 'Dashboard',
          link: {
            name: 'Dashboard',
            icon: 'IconHome',
            to: { name: 'Home' },
            rank: 10,
          },
        },
      },
      {
        path: 'assessment',
        name: 'ModuleArea',
        component: () => import('@user/views_legacy/Default/Routes/ModuleArea'),
        meta: { layout: 'Dashboard' },
      },
      {
        path: 'page-not-found',
        name: 'Custom_PageNotFound',
        component: () => import('@user/views_legacy/Default/Routes/PageNotFound'),
        meta: { layout: 'Error' },
      },
      { path: '*', redirect: '/page-not-found' },
    ],
  },
  {
    path: '/:name',
    name: 'Entry',
    props: true,
    component: () => import('@user/views/Default/Entry'),

    children: [
      { path: '/', redirect: 'login' },

      {
        path: 'home',
        name: 'Home',
        components: {
          default: () => import('@user/views/Default/Routes/Home'),
          side: () => import('@user/views/Default/Routes/Progress'),
        },
        meta: {
          layout: 'Dashboard',
          profileSpecific: true,
          link: {
            name: 'Aufgaben',
            icon: 'IconSupport',
            to: { name: 'Home' },
            rank: 10,
          },
        },
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@user/views/Default/Routes/Login'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () =>
          import('@user/views/Default/Routes/ForgotPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'reset-password/:userHash/:language',
        name: 'ResetPassword',
        component: () => import('@user/views/Default/Routes/ResetPassword'),
        meta: { layout: 'Landing' },
      },
      {
        path: 'profileChooser',
        name: 'ProfileChooser',
        component: () => import('@user/views/Default/Routes/ProfileChooser'),
        meta: {
          layout: 'Dashboard',
          profileSpecific: false,
          link: {
            name: 'Home',
            icon: 'IconHome',
            to: { name: 'ProfileChooser' },
            rank: 5,
          },
        },
      },
      {
        path: 'FAQ',
        name: 'FAQ',
        component: () => import('@user/views/Default/Routes/FAQ'),
        meta: {
          layout: 'Dashboard',
          profileSpecific: false,
          link: { name: 'FAQ', icon: 'IconFAQ', to: { name: 'FAQ' }, rank: 40 },
        },
      },
      {
        path: 'assessment',
        name: 'ModuleArea',
        component: () =>
          import('@user/views/Default/Routes/ModuleArea'),
        meta: { layout: 'Dashboard' },
        props: true,
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@user/views/Default/Routes/Report'),
        meta: {
          layout: 'Dashboard',
          profileSpecific: true,
          link: {
            name: 'Ergebnisbericht',
            icon: 'IconErgebnisbericht',
            to: { name: 'Report' },
            rank: 60,
          },
        },
      },
      {
        path: 'report',
        name: 'ReportOnSite',
        component: () => import('@user/views/Default/Routes/Report'),
        meta: {
          layout: 'Dashboard',
          profileSpecific: true,
          link: {
            name: 'Ergebnisbericht',
            icon: 'IconErgebnisbericht',
            to: { name: 'Report' },
            rank: 60,
          },
        },
      },
      {
        path: 'page-not-found',
        name: 'Custom_PageNotFound',
        component: () => import('@user/views/Default/Routes/PageNotFound'),
        props: { noProject: false },
      },

      { path: '*', redirect: 'page-not-found' },
    ],
  },
];
